import { PropsWithChildren, ReactNode } from 'react';
import { ThemeProvider } from 'react-jss';

import useBaseStyles from '../../styles/useBaseStyles';
import defaultTheme, { ITheme } from '../../styles/theme';

interface ISingleToolsBootstrap {
  theme?: ITheme;
  children: ReactNode;
}

function StyledWrapper({ children }: PropsWithChildren<unknown>) {
  useBaseStyles();

  return <>{children}</>;
}

function SingleToolsBootstrap({ children, theme = defaultTheme }: ISingleToolsBootstrap) {
  return (
    <ThemeProvider theme={theme}>
      <StyledWrapper>{children}</StyledWrapper>
    </ThemeProvider>
  );
}

export default SingleToolsBootstrap;
